
const BlockErreur = () => {
  return (
    <div>
        <h1 className='text-red-400 text-2xl p-4' >ce block n&apos;existe pas</h1>
    </div>
  )
}

export default BlockErreur